import templateUrl from './list-rs-schedules-container.component.html'

export const ListRSSchedulesContainerComponent = {
    templateUrl,
    controller: ListRSSchedulesController,
    controllerAs: "vm"
}

function ListRSSchedulesController(rsScheduleService, utilityService, $q) {
    'ngInject'
    const vm = this;

    vm.$onInit = onInit;
    vm.filters = {};
    vm.onChangeFilters = onChangeFilters;
    vm.onChangePage = onChangePage;
    vm.onSetSort = onSetSort;
    vm.isSortingByField = isSortingByField;
    vm.startDateClean = startDateClean;
    vm.endDateClean = endDateClean;
    vm.sortField = "Program";
    vm.sortDirection = 1; // Ascending.
    vm.columnClass = columnClass;
    let defaultFilter;

    function onInit() {
        if (vm.isSiteAdmin) {
            defaultFilter = { Role: "Owner" };
        } else {
            defaultFilter = {};
        }

        defaultFilter.PageNumber = 1;
        defaultFilter.PageSize = 15;

        utilityService.showLoadingUntilResolved(
            getRotationByDate(new Date().toISOString().slice(0, 10))
                .then(function (rsRotation) {
                    restoreFilters();
                    vm.filters.StartDate = rsRotation.StartDate;
                    vm.filters.EndDate = rsRotation.EndDate;
                    vm.CanSeeNcr = rsRotation.CanSeeNcr;
                    return loadRsSchedulesPage()
                })
                .then(function (page) {
                    vm.rsSchedulesPage = page;
                    vm.rsSchedules = vm.rsSchedulesPage.Entities;
                })
                .catch(function (ex) {
                    console.error(ex);
                    alert("initial load failed:" + utilityService.getExceptionMessage(ex));
                })
        );
    }

    function loadRsSchedulesPage() {
        return rsScheduleService.retrieveRSSchedulesPaged(vm.filters.PageNumber - 1, vm.filters)
            .then(function (rsSchedules) {
                return rsSchedules;
            });
    }

    function getRotationByDate(rsDate) {
        return rsScheduleService.retrieveRotationByDate(rsDate)
            .then(function (rsRotation) {
                return rsRotation;
            });
    }

    const changeFilters = utilityService.debounce(function () {
        vm.filters.PageNumber = 1;
        saveFilters();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadRsSchedulesPage()
                .then(function (page) {
                    vm.rsSchedulesPage = page;
                    vm.rsSchedules = vm.rsSchedulesPage.Entities;
                }), "Filtering failed"));
    }, 500);


    function onChangeFilters() {
        changeFilters();
    }

    function onChangePage() {
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadRsSchedulesPage()
                .then(function (page) {
                    vm.rsSchedulesPage = page;
                    vm.rsSchedules = vm.rsSchedulesPage.Entities;
                }), "Changing page failed"));

        saveFilters();
    }

    function onSetSort(field) {
        if (vm.isSortingByField(field)) {
            vm.sortDirection = vm.sortDirection * -1;
        } else {
            vm.sortDirection = 1;
        }
        vm.filters.SortFields = [(vm.sortDirection === -1 ? "-" : "") + field];
        vm.sortField = field;
        saveFilters();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadRsSchedulesPage()
                .then(function (page) {
                    vm.rsSchedulesPage = page;
                    vm.rsSchedules = vm.rsSchedulesPage.Entities;
                }), "Sorting failed"));
    }

    function isSortingByField(field) {
        return vm.sortField === field;
    }

    function columnClass(field) {
        return vm.sortDirection === -1 ? "fas fa-sort-amount-down" : "fas fa-sort-amount-down-alt";
    }

    function startDateClean() {
        vm.filters.StartDate = undefined;
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadRsSchedulesPage()
                .then(function (page) {
                    vm.rsSchedulesPage = page;
                    vm.rsSchedules = vm.rsSchedulesPage.Entities;
                }), "Changing page failed"));
    }

    function endDateClean() {
        vm.filters.EndDate = undefined;
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadRsSchedulesPage()
                .then(function (page) {
                    vm.rsSchedulesPage = page;
                    vm.rsSchedules = vm.rsSchedulesPage.Entities;
                }), "Changing page failed"));
    }

    function saveFilters() {
        localStorage.setItem("listRSSchedulesFilters", JSON.stringify(vm.filters || {}));
    }

    function restoreFilters() {
        // Restore filters to the grid from localStorage, if available.
        vm.filters = JSON.parse(localStorage.getItem("listRSSchedulesFilters")) || defaultFilter;
        vm.filters.PageNumber = vm.filters.PageNumber || 1;
        vm.filters.PageSize = vm.filters.PageSize || 15;

        if (vm.filters == null) {
            vm.filters = {};
            localStorage.setItem("listRSSchedulesFilters", JSON.stringify(vm.filters));
        }

        if (vm.filters.SortFields && vm.filters.SortFields.length > 0) {
            // Check the first character of the first sort.
            vm.sortDirection = vm.filters.SortFields[0][0] === "-" ? -1 : 1;
            vm.sortField = vm.filters.SortFields[0].replace("-", "");
        }
        return $q.when();
    }
}
